export default "__VITE_ASSET__Bpq02zv$__"